import { Routes } from '@angular/router';
import { redirectLoggedInTo, canActivate } from '@angular/fire/auth-guard';

const redirectLoggedInToHome = () => redirectLoggedInTo(['/pages/earnings']);

export const routes: Routes = [
  {
    path: 'login',
    ...canActivate(redirectLoggedInToHome),
    loadChildren: () => import('./pages/login/login.routes').then(m => m.routes),
  },
  {
    path: 'error/:code',
    loadComponent: () => import('./pages/error/error.page').then(m => m.ErrorPage),
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/tabs/tabs.routes').then(m => m.routes),
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];


